import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  standalone: true,
  selector: 'app-unauthorized',
  imports: [CommonModule, CardModule, ButtonModule, DividerModule],
  templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent {
  private oidc = inject(OidcSecurityService);

  logout() {
    // Prefer full remote sign-out + token revocation if available
    const run$ =
      (this.oidc as any).logoffAndRevokeTokens?.() ??
      (this.oidc as any).logoff?.();

    if (run$ && typeof (run$ as any).subscribe === 'function') {
      (run$ as any).subscribe();
    } else {
      // Fallback (older versions)
      this.oidc.logoff();
    }
  }
}
